export const overOneHourIndicator = '> 1h';
// @param timerValueInS = number of seconds, below an hour - between 0 and 3599
export function getTimeLeft(timerValueInS) {
    if (timerValueInS >= 3600)
        return overOneHourIndicator;
    const secondsLeft = timerValueInS < 1 ? 0 : timerValueInS;
    return new Date(secondsLeft * 1000).toISOString().substr(14, 5);
}
//# sourceMappingURL=remainingTimeFormatter.js.map